import queryString from 'query-string';

import { createGenericDispatcher } from './action-dispatcher-factory';
import { orgStatusSelectorByAccountId } from '../reducers/org-selectors';

import * as Api from '../api/api';

export const loadOrgs = (accountId: number) =>
  createGenericDispatcher<{ [id: number]: Org }>({
    name: 'LOAD_ORGS',
    loadFunction: () => Api.get(`/orgs?${queryString.stringify({ accountId })}`),
    args: { accountId },
    shouldExecuteSelector: (state: any) => orgStatusSelectorByAccountId(state, accountId),
  });
